"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class InvalidResult {
    constructor(reason) {
        this.reason = reason;
    }
}
exports.default = InvalidResult;
